import { generateReplacementStringFromObj } from '@modules/settings/replacements';

import { formatWidthHeight } from '../../_helpers/dimensions';

import PbDashboardPeriodBadge from '../PbDashboardPeriodBadge.vue';
import PbDashboardCardMoveUpDown from './_moveUpDown.vue';

const INVALID_STATES = ['finished', 'canceled', 'error'];

export const CARD_STATES = {
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  IN_GROUP: 'IN_GROUP',
};

export default {
  name: 'PbDashboardCard',

  props: {
    card: {
      type: Object,
      required: true,
    },

    printMachines: {
      type: Array,
      default: () => [],
    },

    suffix: {
      type: String,
      required: true,
    },

    state: {
      type: String,
      validator: value => Object.values(CARD_STATES).includes(value),
    },

    withMoves: {
      type: Boolean,
      default: false,
    },

    isLast: {
      type: Boolean,
      default: false,
    },

    isFirst: {
      type: Boolean,
      default: false,
    },

    forceTop: {
      type: Boolean,
      default: false,
    },

    forceBottom: {
      type: Boolean,
      default: false,
    },

    highlighted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      toQueueSenderMenu: false,
    };
  },

  components: {
    PbDashboardCardMoveUpDown,
    PbDashboardPeriodBadge,
  },

  computed: {
    isWhiteText() {
      return this.$vuetify.theme.dark || this.card.color;
    },

    inGroup() {
      return this.state === CARD_STATES.IN_GROUP;
    },

    notStarted() {
      return this.state === CARD_STATES.NOT_STARTED;
    },

    inProgress() {
      return this.state === CARD_STATES.IN_PROGRESS;
    },

    allowCancelBasketInTray() {
      return this.inProgress && !INVALID_STATES.includes(this.card.state);
    },

    printMachinesExcludeCurrent() {
      return this.printMachines.filter(name => name !== this.card.machine);
    },
  },

  methods: {
    showToQueueSenderDialog(params) {
      this.$emit('send:to-queues-with-replace', params);
      this.toQueueSenderMenu = false;
    },

    formatEndOfStringByCount(str, strEnd, count) {
      return Number(count) === 1 ? str : `${str}${strEnd}`;
    },

    calculateProgressPercentage(part, total) {
      return (!part || !total) ? 0 : (part / total) * 100;
    },

    generateReplacementStringFromObj,
    formatWidthHeight,
  },
};
